// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__TPLII","box":"WorkspacesBox_box__3Ol-Z","node":"WorkspacesBox_node__2OjZL"};